import React from 'react'

export default props => (
  <div className='center norms-16 norms-20-l tc white pre-wrap'>
    <p>{props.children}</p>
  </div>
)
